import { cn } from "@/lib/utils";

type Props = {
  className?: string;
  fill?: string;
};

const JobIcon = ({ className, fill = "#2A2A2A" }: Props) => {
  return (
    <svg
      className={cn("h-[14px] w-[14px] shrink-0", className)}
      viewBox="0 0 14 14"
      fill={fill || "none"}
      xmlns="http://www.w3.org/2000/svg"
    >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.58301 0C8.25513 0.000848473 8.90707 0.23317 9.42773 0.658203C9.94824 1.08314 10.306 1.67487 10.4414 2.33301H11.083C11.8562 2.33393 12.5978 2.6418 13.1445 3.18848C13.6913 3.73526 13.9991 4.47674 14 5.25V11.083C13.9991 11.8563 13.6913 12.5978 13.1445 13.1445C12.5978 13.6913 11.8563 13.9991 11.083 14H2.91699C2.14373 13.9991 1.40225 13.6913 0.855469 13.1445C0.308688 12.5978 0.00092625 11.8563 0 11.083V5.25C0.00092625 4.47674 0.308688 3.73526 0.855469 3.18848C1.40223 2.6418 2.14381 2.33393 2.91699 2.33301H3.55762C3.69303 1.67479 4.05171 1.08318 4.57227 0.658203C5.09293 0.23317 5.74487 0.000848473 6.41699 0H7.58301ZM1.16699 11.083C1.16699 11.5471 1.3515 11.9921 1.67969 12.3203C2.00788 12.6485 2.45286 12.833 2.91699 12.833H11.083C11.5471 12.833 11.9921 12.6485 12.3203 12.3203C12.6485 11.9921 12.833 11.5471 12.833 11.083V8.16699H7.58301V8.75C7.58301 8.90471 7.52151 9.05271 7.41211 9.16211C7.30271 9.27151 7.15471 9.33301 7 9.33301C6.84529 9.33301 6.69729 9.27151 6.58789 9.16211C6.47849 9.05271 6.41699 8.90471 6.41699 8.75V8.16699H1.16699V11.083ZM2.91699 3.5C2.45294 3.5 2.00786 3.68461 1.67969 4.0127C1.3515 4.34088 1.16699 4.78587 1.16699 5.25V7H12.833V5.25C12.833 4.78587 12.6485 4.34088 12.3203 4.0127C11.9921 3.68461 11.5471 3.5 11.083 3.5H2.91699ZM6.41699 1.16699C6.0564 1.16849 5.70417 1.28049 5.41016 1.48926C5.11624 1.69805 4.89365 1.99311 4.77344 2.33301H9.22656C9.10633 1.99306 8.88285 1.69806 8.58887 1.48926C8.29496 1.28072 7.94339 1.16849 7.58301 1.16699H6.41699Z"
      fill={fill}
    />
    </svg>
  );
};

export default JobIcon;
